import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=1b5772b8&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=1b5772b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5772b8",
  null
  
)

export default component.exports